import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import {
  IEmployeeBoxProps,
  IEmployeeBoxPropsContact
} from '../components/employee-box/employee-box';
import { KENTICO_SOCIALMEDIA_CODES } from '../const/common/kentico';

export class EmployeeBoxModel extends ContentItem {
  get firstName(): string | null {
    return get(this._config, 'elements.first_name.value', '') || null;
  }
  get lastName(): string | null {
    return get(this._config, 'elements.last_name.value', '') || null;
  }
  get biography(): string | null {
    return get(this._config, 'elements.biography.value', '') || null;
  }
  get position(): string | null {
    return get(this._config, 'elements.position.value', '') || null;
  }
  get photoUrl(): string | null {
    return get(this._config, 'elements.photo.value[0].url', '') || null;
  }
  get hasAuthorPage(): boolean {
    return (
      get(this._config, 'elements.create_author_page.value[0].codename') ===
      'true'
    );
  }

  get email(): string {
    return get(this._config, 'elements.e_mail.value', '');
  }

  get slug(): string {
    return get(this._config, 'system.codename', '');
  }

  get contact(): IEmployeeBoxPropsContact[] {
    const socialCodes = Object.values(KENTICO_SOCIALMEDIA_CODES);
    const contactArray = socialCodes
      .filter(code => {
        return (
          this.getSocialValue(code).icon !== null &&
          this.getSocialValue(code).url !== null
        );
      })
      .map(code => this.getSocialValue(code));

    return contactArray;
  }

  private checkIfMailAndAddMailto = (mail: string): string =>
    mail.includes('@') && !mail.includes('mailto:')
      ? 'mailto:'.concat(mail)
      : mail;

  private getSocialValue = (code: string): IEmployeeBoxPropsContact => {
    const getIcon = get(this._config, `elements[${code}].name`, '');
    const getUrl = get(this._config, `elements[${code}].value`, '');
    const returnUrl =
      getUrl.includes('@') && getIcon === 'e-mail'
        ? this.checkIfMailAndAddMailto(getUrl)
        : getUrl;

    return {
      icon: getIcon || null,
      url: returnUrl || null
    };
  };

  public static create(data: IEmployeeBox): IEmployeeBoxProps {
    const {
      firstName,
      lastName,
      position,
      photoUrl,
      contact,
      email,
      hasAuthorPage,
      biography,
      slug
    } = new EmployeeBoxModel(data);
    return {
      firstName,
      lastName,
      position,
      photoUrl,
      contact,
      email,
      hasAuthorPage,
      biography,
      slug
    };
  }
}
